import { useEffect, useState } from 'react'
import { clsx } from 'clsx'

/** Grid of media tiles with fast gradient-light sweep when items reveal. */
export function NeonMediaGrid({
  children,
  itemCount,
  columns = 'grid-cols-2 sm:grid-cols-3 md:grid-cols-4',
  className,
  sweepKey,
}: {
  children: React.ReactNode
  itemCount: number
  columns?: string
  className?: string
  /** Change to re-trigger the reveal sweep (e.g. new queue). */
  sweepKey?: string | number
}) {
  const [revealed, setRevealed] = useState(false)

  useEffect(() => {
    setRevealed(false)
    const t = window.setTimeout(() => setRevealed(true), 40)
    return () => window.clearTimeout(t)
  }, [sweepKey, itemCount])

  return (
    <div className={clsx('neon-grid-stage relative', className)}>
      <div
        className={clsx('neon-light-sweep pointer-events-none', revealed && 'neon-light-sweep-active')}
        aria-hidden
      />
      <div
        className={clsx('grid gap-2', columns, revealed && 'neon-grid-revealed')}
        style={{ '--item-count': itemCount } as React.CSSProperties}
      >
        {children}
      </div>
    </div>
  )
}

/** Wrapper for a single tile in the neon grid — staggered pop + per-tile glow. */
export function NeonGridItem({
  index,
  className,
  children,
}: {
  index: number
  className?: string
  children: React.ReactNode
}) {
  return (
    <div
      className={clsx('neon-grid-item relative overflow-hidden', className)}
      style={{ '--i': index } as React.CSSProperties}
    >
      <div className="neon-tile-glow pointer-events-none absolute inset-0 z-10" aria-hidden />
      {children}
    </div>
  )
}